import React from 'react';
import { Modal } from 'antd';
import QuotationInfoAlert from './QuotationInfoAlert';
import QuotationRejectItemsSummary from './QuotationRejectItemsSummary';
import QuotationRejectReasonPanel from './QuotationRejectReasonPanel';

const SELLER_REJECTION_NOTICE =
  'Important: Sellers will be notified about the rejection';

const MODAL_TITLE = {
  all: 'Reject All',
  single: 'Reject',
  buyerSubmitted: 'Reject',
};

export default function QuotationRejectReasonModal({
  open,
  mode,
  items = [],
  onCancel,
  onConfirm,
  loading = false,
}) {
  const title = MODAL_TITLE[mode] || 'Reject';

  return (
    <Modal
      open={open}
      title={title}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
      centered
      zIndex={1100}
      maskClosable={!loading}
      closable={!loading}
      className="Quotation_rejectModal Quotes_modal"
      width={720}
    >
      <QuotationInfoAlert
        message={SELLER_REJECTION_NOTICE}
        className="Quotation_modalAlert--inDialog"
      />
      <QuotationRejectItemsSummary items={items} />
      <QuotationRejectReasonPanel
        key={`${mode}-${items.map((i) => i._id).join(',')}`}
        onConfirm={onConfirm}
        loading={loading}
        inDialog
        confirmLabel="Confirm Rejection"
      />
    </Modal>
  );
}
